import React from "react";
import { Link } from "react-router-dom";
import { getRegionOverride, setRegionOverride } from "@/lib/auMode";

export const SiteFooter = () => {
  const current = getRegionOverride() || "auto";
  const onRegionChange = (e) => {
    const v = e.target.value;
    setRegionOverride(v === "auto" ? "" : v);
    // Reload so clinic data re-fetches with the correct compliance rules.
    window.location.reload();
  };
  return (
    <footer className="border-t border-brand-border/60 bg-brand-cream">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-brand-slate">
        <p data-testid="copyright-notice">
          © {new Date().getFullYear()} AuraLift. All rights reserved. The AuraLift name, design, content and software are protected by copyright and may not be copied or reused.
        </p>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <label className="flex items-center gap-1.5">
            <span className="text-brand-slate/80">Region:</span>
            <select
              data-testid="region-selector"
              value={current}
              onChange={onRegionChange}
              className="rounded-full border border-brand-border bg-white px-2.5 py-1 text-xs text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary/30"
            >
              <option value="auto">Auto-detect</option>
              <option value="au">Australia (TGA/AHPRA)</option>
              <option value="intl">Rest of world</option>
            </select>
          </label>
          <Link to="/legal" data-testid="footer-legal-link" className="hover:text-brand-primary transition-colors">Terms &amp; Privacy</Link>
          <Link to="/clinics" className="hover:text-brand-primary transition-colors">Find a clinic</Link>
        </div>
      </div>
    </footer>
  );
};
